module.exports = __webpack_public_path__ + "static/media/pengaduan_icon.677d50a7.svg";